/* FX Drops: countdown drop cards. One instance per section ([data-fxd]); config comes from
   the section's JSON and each card's data attributes. Everything visual is CSS; this file
   drives timers, text/digit effects, glitch bursts and the star field. */
(function () {
  'use strict';
  if (window.FXDrops) { window.FXDrops.scan(document); return; }

  // Dates: a card set to Los Angeles ('la') turns over at that wall-clock time in Pacific time, daylight saving
  // included, one global moment; 'local' uses each visitor's clock; an explicit offset in the value wins.
  const LA = 'America/Los_Angeles';
  const LAF = new Intl.DateTimeFormat('en-US', { timeZone: LA, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
  const laOff = ms => { const p = {}; LAF.formatToParts(new Date(ms)).forEach(x => { p[x.type] = +x.value; }); return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - ms; };
  const when = (v, tz) => {
    v = (v || '').trim(); if (!v) return NaN;
    if (/(z|[+-]\d\d:?\d\d)$/i.test(v.slice(10))) return Date.parse(v);
    const m = v.match(/^(\d{4})-(\d\d)-(\d\d)(?:T(\d\d):(\d\d)(?::(\d\d))?)?/); if (!m) return Date.parse(v);
    const n = m.slice(1).map(x => +(x || 0));
    if (tz === 'local') return new Date(n[0], n[1] - 1, n[2], n[3], n[4], n[5]).getTime();
    const g = Date.UTC(n[0], n[1] - 1, n[2], n[3], n[4], n[5]); let t = g - laOff(g); t = g - laOff(t); return t;
  };
  // "Oct 6 · 12:00 AM PT · 8:00 AM your time" (the visitor part only when their clock differs from Pacific)
  const whenLine = (ms, withDate) => {
    const d = new Date(ms), f = o => new Intl.DateTimeFormat('en-US', o).format(d);
    let s = (withDate ? f({ timeZone: LA, month: 'short', day: 'numeric' }) + ' · ' : '') + f({ timeZone: LA, hour: 'numeric', minute: '2-digit' }) + ' PT';
    if (laOff(ms) !== -d.getTimezoneOffset() * 60000) {
      const sameDay = f({ timeZone: LA, dateStyle: 'short' }) === f({ dateStyle: 'short' });
      s += ' · ' + f(sameDay ? { hour: 'numeric', minute: '2-digit' } : { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' your time';
    }
    return s;
  };
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const PHONE = matchMedia('(max-width: 749px)');
  // Glyph ranges chosen for iPhone font coverage (Misc Technical, Math Operators, Misc Symbols).
  const SETS = {
    alien: '⏃⏚☊⎎⊑⌰⋔⋏⍜⌿⍾⍀⌇⏁⎍⎐⍙⌖⊬⋉☌☍⏄⏆⍟⌬',
    decrypt: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*+=<>/\\',
    hex: '0123456789ABCDEF',
    katakana: 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン',
    digits: '0123456789'
  };
  const pick = s => s[(Math.random() * s.length) | 0];
  const pad = n => String(n).padStart(2, '0');

  /* ------------------------------------------------ text scrambler (keeps markup, edits text nodes) */
  function scrambler(el, charset) {
    const nodes = [], walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walk.nextNode()) nodes.push(walk.currentNode);
    const orig = nodes.map(n => n.nodeValue);
    const full = orig.join('');
    if (full.trim() && !el.getAttribute('aria-label')) el.setAttribute('aria-label', full.trim().replace(/\s+/g, ' '));
    let run = 0, locked = false;
    // freeze the element's box while glyphs are showing, so wider characters can't reflow the page
    const lock = () => {
      if (locked) return; const r = el.getBoundingClientRect(); if (!r.width) return;
      locked = true; el.style.width = r.width + 'px'; el.style.height = r.height + 'px'; el.classList.add('fxd-lock');
    };
    const unlock = () => { if (!locked) return; locked = false; el.style.width = ''; el.style.height = ''; el.classList.remove('fxd-lock'); };
    const api = {
      hide() { nodes.forEach((n, k) => { n.nodeValue = orig[k].replace(/\S/g, () => pick(charset)); }); },
      restore() { run++; nodes.forEach((n, k) => { n.nodeValue = orig[k]; }); unlock(); },
      play(ms, stagger, share = 1) {
        const id = ++run, t0 = performance.now(), total = full.length, at = new Float32Array(total), on = new Uint8Array(total);
        lock();
        for (let k = 0; k < total; k++) { on[k] = Math.random() < share ? 1 : 0; at[k] = k * stagger + ms * (0.45 + Math.random() * 0.55); }
        let last = 0;
        const step = now => {
          if (id !== run) return;
          const t = now - t0; let busy = false;
          if (now - last > 40) {
            last = now; let k = 0;
            nodes.forEach((n, ni) => {
              let s = '';
              for (const ch of orig[ni]) { if (ch.trim() && on[k] && t < at[k]) { s += pick(charset); busy = true; } else s += ch; k++; }
              n.nodeValue = s;
            });
          } else busy = true;
          busy ? requestAnimationFrame(step) : (api.restore(), unlock());
        };
        requestAnimationFrame(step);
      },
      type(ms) {
        const id = ++run, t0 = performance.now(), total = full.length;
        el.classList.add('fxd-type');
        const step = now => {
          if (id !== run) return;
          const n = Math.min(total, Math.floor((now - t0) / (ms / Math.max(total, 1))));
          let k = 0;
          nodes.forEach((node, ni) => { let s = ''; for (const ch of orig[ni]) { s += k < n ? ch : (ch === ' ' ? ' ' : ' '); k++; } node.nodeValue = s; });
          if (n < total) requestAnimationFrame(step); else { api.restore(); setTimeout(() => el.classList.remove('fxd-type'), 1200); }
        };
        requestAnimationFrame(step);
      }
    };
    return api;
  }

  /* ------------------------------------------------ one section */
  class Drops {
    constructor(root) {
      this.root = root; root.__fxd = this;
      const c = root.querySelector(':scope > .fxd-cfg');
      this.cfg = c ? JSON.parse(c.textContent) : {};
      this.design = !!(window.Shopify && window.Shopify.designMode);
      this.still = this.cfg.s_rm === 'respect' && RM.matches;
      this.mobileMode = PHONE.matches ? this.cfg.s_mfx : 'full';
      if (this.mobileMode === 'off') this.still = true;
      root.classList.toggle('is-still', this.still);
      root.classList.toggle('is-lite', this.mobileMode === 'lite');
      this.timers = new Set(); this.offs = []; this.cards = [...root.querySelectorAll('.fxd-card')];
      this.visible = true;
      this.observe();
      this.cards.forEach(card => this.initCard(card));
      this.tick(true);
      this.every(1000, () => this.tick(false));
      if (!this.still) { this.initGlitch(); this.initStars(); this.initReveal(); }
    }
    later(fn, ms) { const id = setTimeout(() => { this.timers.delete(id); fn(); }, ms); this.timers.add(id); return id; }
    every(ms, fn) { const loop = () => { fn(); this.later(loop, ms - (Date.now() % ms) + 5); }; this.later(loop, ms - (Date.now() % ms) + 5); }
    on(t, e, f, o) { t.addEventListener(e, f, o); this.offs.push(() => t.removeEventListener(e, f, o)); }

    observe() {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.target === this.root) { this.visible = e.isIntersecting; this.root.classList.toggle('is-idle', !e.isIntersecting); this.root.querySelectorAll('video').forEach(v => { e.isIntersecting && !this.still ? v.play().catch(() => {}) : v.pause(); }); return; }
        if (e.isIntersecting && !e.target.classList.contains('is-in')) { e.target.classList.add('is-in'); this.reveal(e.target); }
      }), { threshold: [0, .15] });
      io.observe(this.root); this.cards.forEach(c => io.observe(c));
      this.offs.push(() => io.disconnect());
      if (this.cfg.s_in && !this.still) this.root.classList.add('has-in');
    }

    initCard(card) {
      const c = this.cfg;
      card.__end = when(card.dataset.end, card.dataset.tz);
      // the start time in the visitor's own zone, under the date line or the timer, until the drop opens
      if (c.s_when && !isNaN(card.__end) && Date.now() < card.__end) {
        const at = card.querySelector('.fxd-date') || card.querySelector('.fxd-tw');
        if (at && !card.querySelector('.fxd-when')) { const w = document.createElement('div'); w.className = 'fxd-when'; w.textContent = whenLine(card.__end, !card.querySelector('.fxd-date')); at.after(w); }
      }
      card.__start = card.__end - (c.s_bar_days || 30) * 86400000;
      card.__digits = [...card.querySelectorAll('.t b')].map(b => ({ b, spans: [...b.querySelectorAll('span')] }));
      const name = card.querySelector('.fxd-name'), st = card.querySelector('.fxd-top .st span'), meta = card.querySelectorAll('.fxd-top > span:first-child, .fxd-chap');
      const set = SETS[c.s_nfx === 'alien' ? 'alien' : c.s_nset] || SETS.decrypt;
      card.__name = name && scrambler(name, set);
      card.__status = st && scrambler(st, c.s_sfx === 'alien' ? SETS.alien : SETS.decrypt);
      card.__meta = [...meta].map(m => scrambler(m, SETS.decrypt));
      if (!this.still && card.__name && ['decrypt', 'alien'].includes(c.s_nfx) && ['load', 'both'].includes(c.s_nwhen)) card.__name.hide();
      if (!this.still && card.__status && ['typewriter', 'scramble', 'alien'].includes(c.s_sfx)) card.__status.hide();
      if (c.s_nfx === 'alien' || c.s_tfx === 'alien') card.classList.add('has-alien');
    }
    reveal(card) {
      if (this.still) return;
      const c = this.cfg, ms = c.s_nms;
      if (card.__name && ['load', 'both'].includes(c.s_nwhen)) {
        if (c.s_nfx === 'decrypt' || c.s_nfx === 'alien') card.__name.play(ms, 28);
        if (c.s_nfx === 'typewriter') card.__name.type(ms);
        if (c.s_nfx === 'glitch') this.glitchText(card);
      }
      if (card.__status) {
        if (c.s_sfx === 'typewriter') this.later(() => card.__status.type(700), 300);
        if (c.s_sfx === 'scramble' || c.s_sfx === 'alien') this.later(() => card.__status.play(700, 30), 300);
      }
      if (c.s_tfx === 'alien' || c.s_tfx === 'scramble') this.decodeTimer(card, c.s_tfx === 'alien' ? SETS.alien : SETS.digits, 900);
      if (c.s_nwhen === 'loop' || c.s_nwhen === 'both') {
        const loop = () => { if (this.visible && !document.hidden) this.textPulse(card); this.later(loop, c.s_nevery * 1000 * (0.75 + Math.random() * 0.5)); };
        this.later(loop, c.s_nevery * 1000);
      }
      if (c.s_sfx === 'glitch' && card.__status) {
        const loop = () => { if (this.visible) { card.__status.play(300, 0, .5); } this.later(loop, 4000 + Math.random() * 5000); };
        this.later(loop, 2500);
      }
    }
    textPulse(card) {
      const c = this.cfg;
      if (!card.__name) return;
      if (c.s_nfx === 'glitch') return this.glitchText(card);
      if (c.s_nfx === 'decrypt' || c.s_nfx === 'alien') return card.__name.play(c.s_nms * .6, 0, .35);
      if (c.s_nfx === 'typewriter') return card.__name.type(c.s_nms);
    }
    glitchText(card) { const n = card.querySelector('.fxd-name'); if (!n) return; n.classList.remove('is-glitch'); void n.offsetWidth; n.classList.add('is-glitch'); }

    /* ---------------- timers */
    tick(first) {
      const now = Date.now(), c = this.cfg;
      for (const card of this.cards) {
        const pv = this.design ? card.dataset.preview : 'count';
        const phases = [['end', 0], ['t1', 1], ['t2', 2], ['close', 3]].map(([k, i]) => ({ t: when(card.dataset[k], card.dataset.tz), i })).filter(p => !isNaN(p.t));
        if (!phases.length) continue;
        const at = pv === 'closed' ? Infinity : pv === 'live' ? phases[0].t + 1000 : now;
        let target;
        if (phases.length > 1) {
          // full pre-order schedule: release, tier 1, tier 2, close
          if (at >= phases[0].t && !card.classList.contains('is-live')) this.goOpen(card);
          const next = phases.find(p => p.t > at);
          if (!next) { if (!card.classList.contains('is-closed')) this.goClosed(card, first); continue; }
          // released with the countdown switched off: no timer, the "now live" line instead, until the close date
          if (at >= phases[0].t && card.dataset.liveTimer === 'off') { if (!card.__quiet) { card.__quiet = true; this.goQuiet(card, first); } continue; }
          const ph = card.querySelector('.fxd-phase');
          if (ph && ph.__i !== next.i) { ph.__i = next.i; ph.textContent = ph.dataset['l' + next.i] || ''; if (!first && !this.still) scrambler(ph, SETS.decrypt).play(600, 20); }
          target = next.t;
        } else {
          const ended = at >= phases[0].t;
          if (ended && !card.classList.contains('is-live')) this.goLive(card, first);
          if (ended) continue;
          target = phases[0].t;
        }
        const left = Math.max(0, Math.floor((target - (pv === 'live' ? phases[0].t + 1000 : now)) / 1000));
        let s = left; const v = {};
        if (c.s_ud) { v.d = Math.floor(s / 86400); s %= 86400; }
        if (c.s_uh) { v.h = Math.floor(s / 3600); s %= 3600; }
        if (c.s_um) { v.m = Math.floor(s / 60); s %= 60; }
        if (c.s_us) v.s = s;
        const vals = ['d', 'h', 'm', 's'].filter(k => k in v).map(k => pad(v[k]));
        card.__digits.forEach((d, i) => this.setDigits(card, d, vals[i] || '00', first));
        const bar = card.querySelector('.fxd-bar');
        if (bar) { const pct = Math.min(100, Math.max(0, (now - card.__start) / (card.__end - card.__start) * 100)); bar.style.setProperty('--prog', pct.toFixed(2) + '%'); const l = bar.querySelector('.pct'); if (l) l.textContent = (c.s_bar_label || 'Uplink') + ' ' + pct.toFixed(1) + '%'; }
      }
    }
    setDigits(card, d, str, first) {
      while (d.spans.length < str.length) { const s = document.createElement('span'); s.textContent = '0'; d.b.prepend(s); d.spans.unshift(s); }
      while (d.spans.length > str.length) d.spans.shift().remove();
      const fx = this.still ? 'none' : this.cfg.s_tfx, ms = this.cfg.s_tms;
      [...str].forEach((ch, j) => {
        const sp = d.spans[j];
        if (sp.__want === ch) return;
        sp.__want = ch;
        if (first || fx === 'none' || sp.__busy) { sp.textContent = ch; return; }
        if (fx === 'scramble' || fx === 'alien') {
          const set = fx === 'alien' ? SETS.alien : SETS.digits, t0 = performance.now(); sp.__busy = true;
          if (fx === 'alien') sp.classList.add('d-alien');
          const step = () => {
            if (performance.now() - t0 > ms) { sp.textContent = sp.__want; sp.classList.remove('d-alien'); sp.__busy = false; return; }
            sp.textContent = pick(set); setTimeout(step, 45);
          };
          step(); return;
        }
        sp.textContent = ch; sp.className = ''; void sp.offsetWidth; sp.className = 'd-' + fx;
      });
    }
    decodeTimer(card, set, ms) {
      card.__digits.forEach(d => d.spans.forEach((sp, j) => {
        const t0 = performance.now() + j * 60; sp.__busy = true;
        if (set === SETS.alien) sp.classList.add('d-alien');
        const step = () => { if (performance.now() - t0 > ms) { sp.textContent = sp.__want || sp.textContent; sp.classList.remove('d-alien'); sp.__busy = false; return; } sp.textContent = pick(set); setTimeout(step, 50); };
        step();
      }));
    }
    setDateLine(card, text) {
      // title + date cards: once released, the start date line becomes the status
      const d = card.querySelector('.fxd-date');
      if (d && text) { d.textContent = text; d.classList.add('is-status'); }
    }
    goOpen(card) {
      card.querySelectorAll('.fxd-when').forEach(w => { w.hidden = true; });
      // released: pre-order is open, the timer keeps running toward the next tier
      card.classList.add('is-live');
      this.setDateLine(card, card.dataset.liveStatus);
      const st = card.querySelector('.fxd-top .st span');
      if (st && card.dataset.liveStatus) { st.textContent = card.dataset.liveStatus; card.__status = scrambler(st, SETS.decrypt); }
      const btn = card.querySelector('.fxd-btn');
      if (btn) { const l = btn.querySelector('.lbl'); if (l && card.dataset.liveLabel) l.textContent = card.dataset.liveLabel; if (card.dataset.liveHref) { btn.setAttribute('href', card.dataset.liveHref); btn.hidden = false; } }
    }
    goQuiet(card, first) {
      ['.fxd-tw', '.fxd-bar', '.fxd-phase'].forEach(q => { const el = card.querySelector(q); if (el) el.hidden = true; });
      const exp = card.querySelector('.fxd-exp:not(.fxd-exp-closed)');
      if (exp) { exp.hidden = false; if (!first && !this.still) scrambler(exp, this.cfg.s_nfx === 'alien' ? SETS.alien : SETS.decrypt).play(900, 25); }
    }
    goClosed(card, first) {
      card.classList.add('is-live', 'is-closed');
      this.setDateLine(card, card.dataset.closedStatus);
      ['.fxd-tw', '.fxd-bar', '.fxd-phase', '.fxd-exp:not(.fxd-exp-closed)'].forEach(q => { const el = card.querySelector(q); if (el) el.hidden = true; });
      const exp = card.querySelector('.fxd-exp-closed'); if (exp) exp.hidden = false;
      const st = card.querySelector('.fxd-top .st span'); if (st && card.dataset.closedStatus) st.textContent = card.dataset.closedStatus;
      const btn = card.querySelector('.fxd-btn'); if (btn) { const l = btn.querySelector('.lbl'); if (l && card.dataset.closedLabel) l.textContent = card.dataset.closedLabel; if (card.dataset.liveHref) { btn.setAttribute('href', card.dataset.liveHref); btn.hidden = false; } }
    }
    goLive(card, first) {
      card.querySelectorAll('.fxd-when').forEach(w => { w.hidden = true; });
      card.classList.add('is-live');
      this.setDateLine(card, card.dataset.liveStatus);
      const tw = card.querySelector('.fxd-tw'), exp = card.querySelector('.fxd-exp:not(.fxd-exp-closed)'), bar = card.querySelector('.fxd-bar');
      if (tw) tw.hidden = true; if (bar) bar.hidden = true;
      const phl = card.querySelector('.fxd-phase'); if (phl) phl.hidden = true;
      if (exp) { exp.hidden = false; if (!first && !this.still) scrambler(exp, this.cfg.s_nfx === 'alien' ? SETS.alien : SETS.decrypt).play(900, 25); }
      const st = card.querySelector('.fxd-top .st span');
      if (st && card.dataset.liveStatus) { st.textContent = card.dataset.liveStatus; card.__status = scrambler(st, SETS.decrypt); }
      const btn = card.querySelector('.fxd-btn');
      if (btn) {
        if (card.dataset.liveLabel) { const l = btn.querySelector('.lbl'); if (l) l.textContent = card.dataset.liveLabel; }
        if (card.dataset.liveHref) { btn.setAttribute('href', card.dataset.liveHref); btn.hidden = false; }
        btn.hidden = false;
      }
    }

    /* ---------------- scan reveal: one sweep, then hold lit until the next */
    initReveal() {
      const cards = this.cards.filter(c => c.classList.contains('tr-reveal'));
      if (!cards.length) return;
      const every = (this.cfg.s_rev_every || 12) * 1000;
      const sweep = card => {
        card.classList.remove('rv'); void card.offsetWidth; card.classList.add('rv');
        if (this.cfg.s_rev_text) this.beamText(card);
      };
      cards.forEach((card, i) => {
        const loop = () => { if (this.visible && !document.hidden) sweep(card); this.later(loop, every); };
        this.later(loop, 2600 + i * 700);
      });
    }

    /* the reveal beam decrypts each line of text as it crosses it: glyphs, then back to English */
    beamText(card) {
      const set = SETS[this.cfg.s_rev_set] || SETS.alien;
      const cr = card.getBoundingClientRect();
      const targets = [...card.querySelectorAll('.fxd-top .st > span, .fxd-top > span:first-child, .fxd-chap, .fxd-name, .fxd-sub, .fxd-date, .fxd-phase, .fxd-exp:not([hidden]), .t i, .fxd-btn .lbl')]
        .filter(el => el.offsetParent !== null && el.textContent.trim())
        .map(el => { const r = el.getBoundingClientRect(); return { el, f: ((r.top + r.height / 2) - cr.top) / cr.height * 100, done: false }; });
      const timer = card.querySelector('.fxd-tw:not([hidden]) .t');
      const tf = timer ? ((timer.getBoundingClientRect().top + timer.getBoundingClientRect().height * .35) - cr.top) / cr.height * 100 : -1;
      let timerDone = !timer, t0 = performance.now();
      const step = () => {
        const p = parseFloat(getComputedStyle(card).getPropertyValue('--fxd-p')) || 0;
        for (const t of targets) if (!t.done && p >= t.f) {
          t.done = true;
          scrambler(t.el, set).play(t.el.classList.contains('fxd-name') ? 520 : 480, t.el.classList.contains('fxd-name') ? 10 : 8);
        }
        if (!timerDone && p >= tf) { timerDone = true; this.decodeTimer(card, set, 520); }
        if ((p < 103 || performance.now() - t0 < 300) && performance.now() - t0 < 12000) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    /* ---------------- render glitch bursts */
    initGlitch() {
      const every = this.cfg.s_glitch_every * 1000;
      if (this.cfg.s_glitch === 'off') return;
      const strong = this.cfg.s_glitch === 'strong';
      this.cards.forEach((card, i) => {
        const burst = () => {
          if (this.visible && !document.hidden) { card.classList.remove('is-glitch'); void card.offsetWidth; card.classList.add('is-glitch'); if (strong) this.later(() => { card.classList.remove('is-glitch'); void card.offsetWidth; card.classList.add('is-glitch'); }, 180); }
          this.later(burst, every * (0.6 + Math.random() * 0.8));
        };
        this.later(burst, every * (0.3 + i * 0.37 % 1));
      });
    }

    /* ---------------- stars */
    initStars() {
      if (this.root.classList.contains('is-lite')) return;
      const canv = [...this.root.querySelectorAll('canvas.fxd-stars')];
      if (!canv.length) return;
      const skies = canv.map(cv => ({ cv, stars: Array.from({ length: 150 }, () => ({ x: Math.random() * 2 - 1, y: Math.random() * 2 - 1, z: Math.random() })) }));
      let last = 0, raf = 0;
      const draw = t => {
        raf = requestAnimationFrame(draw);
        if (!this.visible || document.hidden) { last = t; return; }
        const dt = Math.min(50, t - (last || t)); last = t;
        const spd = this.cfg.s_speed / 100 * this.cfg.s_star_spd / 100;
        for (const { cv, stars } of skies) {
          const w = cv.clientWidth, h = cv.clientHeight; if (!w) continue;
          const dpr = Math.min(devicePixelRatio || 1, 1.5);
          if (cv.width !== Math.round(w * dpr)) { cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); }
          const x = cv.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, 0, 0); x.clearRect(0, 0, w, h);
          for (const s of stars) {
            s.z -= dt * 0.00005 * spd; if (s.z <= .02) { s.z = 1; s.x = Math.random() * 2 - 1; s.y = Math.random() * 2 - 1; }
            const px = w / 2 + s.x / s.z * w * .35, py = h * .45 + s.y / s.z * h * .35, r = (1 - s.z) * 1.6 + .2;
            if (px < 0 || px > w || py < 0 || py > h) continue;
            x.fillStyle = 'rgba(210,235,255,' + (1 - s.z).toFixed(2) + ')'; x.fillRect(px, py, r, r);
          }
        }
      };
      raf = requestAnimationFrame(draw);
      this.offs.push(() => cancelAnimationFrame(raf));
    }

    destroy() {
      this.timers.forEach(clearTimeout); this.offs.forEach(f => f());
      this.cards.forEach(card => { card.__name && card.__name.restore(); card.__status && card.__status.restore(); (card.__meta || []).forEach(m => m.restore()); });
      delete this.root.__fxd;
    }
  }

  function scan(scope) {
    (scope.matches && scope.matches('[data-fxd]') ? [scope] : [...scope.querySelectorAll('[data-fxd]')]).forEach(root => {
      if (root.__fxd) root.__fxd.destroy();
      try { new Drops(root); } catch (e) { console.error('[fx-drops]', e); }
    });
  }
  window.FXDrops = { scan };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => scan(document)) : scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-fxd]').forEach(r => r.__fxd && r.__fxd.destroy()));
})();
